function NotFound(){
  return(
    <h1>No encontrado</h1>
  );
}

export default NotFound;